import { FormItemConfig } from '@ms/shared-components';
import { Tag } from '../../../types/space';
import SvgIconUpload from '../components/SvgIconUpload';

// 表单宽度
export const FORM_WIDTH = 600;

// 表单弹窗高度
export const FORM_HEIGHT = "auto";

// 表单布局
export const FORM_LAYOUT = {
  layout: 'horizontal' as const,
  labelCol: { span: 6 },
  wrapperCol: { span: 18 }
};

// 创建表单项配置
export const createTagFormItems = (
  _editingTag?: Tag | null
): FormItemConfig[] => [
  {
    name: 'name',
    label: '标签名称',
    type: 'input',
    props: {
      placeholder: '请输入标签名称'
    },
    rules: [
      { required: true, message: '请输入标签名称' },
      { max: 50, message: '标签名称不能超过50个字符' }
    ]
  },
  {
    name: 'icon',
    label: '标签图标',
    type: 'custom',
    customComponent: SvgIconUpload,
    props: {
      placeholder: '请输入SVG代码，或点击上传SVG文件'
    }
  },
  {
    name: 'description',
    label: '描述',
    type: 'textarea',
    props: {
      placeholder: '请输入标签描述',
      rows: 4,
      maxLength: 200,
      showCount: true
    }
  }
];

// 获取默认表单值
export const getDefaultFormValues = (editingTag?: Tag | null) => {
  if (editingTag) {
    return {
      name: editingTag.name,
      icon: editingTag.icon,
      description: editingTag.description
    };
  }
  return {};
};

// 获取表单标题
export const getFormTitle = (isEdit: boolean) => {
  return isEdit ? '编辑标签' : '新建标签';
};
